import Alerts from "./Alerts";
import AlertsPortal from "./AlertsPortal";

function AlertsWrapper() {
  return (
    <AlertsPortal>
      <Alerts />
    </AlertsPortal>
  );
}

export default AlertsWrapper;
